import {setMessage, isVisible} from './message'
import {setLoadingStatus} from './loaderAction';

/**
* Setter for file data
*/
export const fileData = 'FILEDATA';

export const setFileData = (data) => {
  return {
  		type: fileData,
  		fetchedFileData: data
  	}
}

/**
* Setter for file category data
*/
export const fileTypeData = 'FILETYPEDATA';


export const setFileTypeData = (data) => {
  return {
        type: fileTypeData,
        fetchedFileTypeData: data
    }
}

/**
* Setter for file meta data
*/
export const fileMetaDataCategory = 'FILEMETADATACATEGORY';
export const fileMetaDataValue = 'FILEMETADATAVALUE';
export const fileMetaDataValueWithCategory = 'METAVALUESWITHCATEGORY';

export const setFileMetaDataCategory = (data) => {
  return {
        type: fileMetaDataCategory,
        fetchedFileMetaData: data
    }
}

export const setFileMetaDataValue = (data) => {
  return {
        type: fileMetaDataValue,
        fetchedFileMetaData: data
    }
}


export const setFileMetaDataWithCategoryValue = (data) => {

  return {
        type: fileMetaDataValueWithCategory,
        fetchedFileMetaData: data
    }
}




/**
* Fetch file data
*/
export const fileFetchData = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileReducer', status: true}))
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            //-- set clients data
            dispatch(setLoadingStatus({reducer: 'FileReducer', status: false}))

    
            dispatch(setFileData(data))

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan file data niet ophalen'})));
    };
}

/**
* Fetch file category data
*/
export const fileTypeFetchData = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileTypeReducer', status: true}))
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            dispatch(setLoadingStatus({reducer: 'FileTypeReducer', status: false}))
            //-- set clients data
            dispatch(setFileTypeData(data))

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan filecategory data niet ophalen'})));
    };
}

/**
* Add the file category
*/
export const addFileType = (url, postData, metaCategories) => {

    let data = new FormData;

    data.append('postData', JSON.stringify(postData) );
    data.append('metaCategories', JSON.stringify(metaCategories));

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileTypeReducer', status: true}))
        fetch(url + '/api/files/action/addFileType',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                dispatch(setLoadingStatus({reducer: 'FileTypeReducer', status: false}))
                dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes'))
                dispatch(setMessage(data.message))


            })
            .catch((error) => {


            });
    };
}

/**
* Fetch file meta data
*/
export const fileMetaDataCategoryFetchData = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: true}))
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: false}))
            //-- set clients data
            dispatch(setFileMetaDataCategory(data))

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan file meta data niet ophalen'})));
    };
}

/**
* Add the file metadata
*/
export const addFileMetaDataCategory = (url, postData) => {

    let data = new FormData;

    data.append('postData', JSON.stringify(postData) );

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: true}))
        fetch(url + '/api/files/action/addFileMetaDataCategory',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: false}))
                dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories'))
                dispatch(setMessage(data.message))


            })
            .catch((error) => {


            });
    };
}

/**
* Fetch file meta data
*/
export const fileMetaDataValueFetchData = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: true}))
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: false}))
            //-- set clients data
            dispatch(setFileMetaDataValue(data))

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan file meta data niet ophalen'})));
    };
}

/**
* Fetch file meta data with category
*/
export const fileMetaDataValueWithCategoryFetchData = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: true}))
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            //-- set clients data
            dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: false}))
            dispatch(setFileMetaDataWithCategoryValue(data))

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan file meta data niet ophalen'})));
    };
}


/**
* Add the file metadata
*/
export const addFileMetaDataValue = (url, postData) => {

    let data = new FormData;

    data.append('postData', JSON.stringify(postData) );

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: true}))
        fetch(url + '/api/files/action/addFileMetaDataValue',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: false}))
                //dispatch(fileMetaDataValueFetchData(url + '/api/files/action/getFileMetaDataValue'))
                dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories'))

                dispatch(setMessage(data.message))


            })
            .catch((error) => {


            });
    };
}

/**
* reorder metafileDataValue
*/
export const reorderFileMetaDataValue = (url, postData) => {

    let data = new FormData;

    data.append('postData', JSON.stringify(postData) );

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: true}))
        fetch(url + '/api/files/action/reorderFileMetaDataValue',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                dispatch(setLoadingStatus({reducer: 'FileMetaDataCategoryReducer', status: false}))
                dispatch(fileMetaDataValueFetchData(url + '/api/files/action/getFileMetaDataValue'))
                dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories'))

                dispatch(setMessage(data.message))


            })
            .catch((error) => {


            });
    };
}

    /**
* reorder metacategories in filetype
*/
export const reorderFileTypeMetaCategory = (url, postData) => {

    let data = new FormData;

    data.append('postData', JSON.stringify(postData) );

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileTypeReducer', status: true}))
        fetch(url + '/api/files/action/reorderFileTypeMetaCategory',
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {

            dispatch(setLoadingStatus({reducer: 'FileTypeReducer', status: false}))
            dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes'))

            dispatch(setMessage(data.message))


        })
        .catch((error) => {

        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/fileData.js